var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSubtract = function SvgSubtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 58 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M52.751 32c0 14.912-12.088 27-27 27a26.902 26.902 0 0 1-18.138-7H.77c5.864 7.316 14.876 12 24.981 12 17.674 0 32-14.327 32-32 0-17.673-14.326-32-32-32C15.193 0 5.828 5.114 0 13h6.568c4.893-4.94 11.68-8 19.183-8 14.912 0 27 12.088 27 27Z",
    clipRule: "evenodd"
  })));
};
export default SvgSubtract;